import React from "react";
import { useTranslation } from "react-i18next";

const ErrorFallback: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "18px",
        color: "#666",
        textAlign: "center",
        padding: "20px",
      }}
    >
      {t("translations.message.error.unexpectedError")}
    </div>
  );
};

export default ErrorFallback;
